import(/* webpackMode: "eager", webpackExports: ["PageHackreation"] */ "/home/runner/work/Mitobyte/Mitobyte/src/app/events/hackreation/__page__/PageHackreation.tsx");
